import { useMemo } from 'react';
import { useIndustryLabel } from '@/components/members';
import { useMe } from '@/lib/queries/identity';
import type { IntakePrefillValues } from './intake-answer-model';

// Applicant profile values used to prefill recommended region/sector intake
// questions: region <- the profile's place text (fallback: the legacy location
// string); sector <- the localized label of the profile's industry code.
// Empty until the profile query resolves — it is cached app-wide so this is
// usually immediate, and a late resolve re-seeds only still-empty prefill
// fields (mergeAnswers never overwrites a touched answer). Shared by both
// applicant surfaces (member join A/B, Circle→Network C).
export function useIntakePrefill(): IntakePrefillValues {
  const { data } = useMe();
  const industryLabel = useIndustryLabel();
  return useMemo(() => {
    if (data === undefined) return {};
    const out: IntakePrefillValues = {};
    const region = data.place?.text ?? data.location;
    if (region != null && region.trim().length > 0) out.region = region;
    if (data.industryCode !== undefined) out.sector = industryLabel(data.industryCode);
    return out;
  }, [data, industryLabel]);
}
